// Helper to make dates easy to mock in unit tests.
const DateNow = () => Date.now();

export default DateNow;
